import type {QRGeneratorLogo} from '@Components/qr-code-generator/qr-code-generator.types';

export interface QRCustomizeMenuProps {
  logo: QRGeneratorLogo | null;
  onLogoChange: (logo: QRGeneratorLogo | null) => void;
  onStyleOpen: () => void;
}

export enum QRCustomizeAction {
  STYLE = 'style',
  LOGO = 'logo',
}

export interface QRCustomizeMenuRow {
  action: QRCustomizeAction;
  labelKey: string;
  descriptionKey: string;
  icon: string;
}

export const QR_CUSTOMIZE_STYLE_ROW: QRCustomizeMenuRow = {
  action: QRCustomizeAction.STYLE,
  labelKey: 'pmwjs_qr_generator_style_qr',
  descriptionKey: 'pmwjs_qr_generator_style_qr_description',
  icon: 'icon-magic-wand',
};

export const QR_CUSTOMIZE_ADD_LOGO_ROW: QRCustomizeMenuRow = {
  action: QRCustomizeAction.LOGO,
  labelKey: 'pmwjs_qr_generator_add_logo',
  descriptionKey: 'pmwjs_qr_generator_add_logo_description',
  icon: 'icon-plus',
};

export const QR_CUSTOMIZE_REMOVE_LOGO_ROW: QRCustomizeMenuRow = {
  action: QRCustomizeAction.LOGO,
  labelKey: 'pmwjs_qr_generator_remove_logo',
  descriptionKey: 'pmwjs_qr_generator_remove_logo_description',
  icon: 'icon-close',
};
